const form = document.querySelector('.references-filters');
const results = document.querySelector('#references-results');
const formOverlay = document.querySelector('.references-filters-overlay');
const filterCounter = document.querySelector('.filters-counter');

if (form && results) {

    const updateResultsCount = (count = null) => {

        if (count === null) {
            count = results.querySelectorAll('.reference-card').length;
        }

        document
            .querySelectorAll('.references-counter__number')
            .forEach(counter => counter.textContent = count);

    };

    const loadReferences = async (page = 1) => {

        results.classList.add('loading');

        const formData = new FormData(form);

        formData.append('action', 'filter_references');
        formData.append('paged', page);

        try {

            const response = await fetch(
                referencesAjax.ajaxurl,
                {
                    method: 'POST',
                    body: formData
                }
            );

            const json = await response.json();

            if (json.success) {

                results.innerHTML = json.data.html;

                updateResultsCount(json.data.total);

            }

        } catch (error) {

            console.error(
                'Erreur lors du filtrage des références',
                error
            );

        } finally {

            results.classList.remove('loading');

        }

    };

    // updateResultsCount();

    form.addEventListener('change', () => {
        loadReferences(1);
    });

    document.addEventListener('click', (e) => {

        const paginationLink = e.target.closest('.references-pagination a');

        if (!paginationLink) {
            return;
        }

        e.preventDefault();

        loadReferences(
            parseInt(
                paginationLink.dataset.page,
                10
            )
        );

        window.scrollTo({
            top: results.getBoundingClientRect().top + window.scrollY - 150,
            behavior: 'smooth'
        });

    });

    document.querySelectorAll('.filter-group__title').forEach(title => {

        title.addEventListener('click', () => {

            const currentGroup = title.closest('.filter-group');

            document.querySelectorAll('.filter-group').forEach(group => {

                if (group !== currentGroup) {
                    group.classList.remove('active');
                }

            });

            currentGroup.classList.toggle('active');

        });

    });

    const removeAll = document.querySelector('.remove-all');

    if (removeAll) {

        removeAll.addEventListener('click', (e) => {

            e.preventDefault();

            form.querySelectorAll('input[type="checkbox"]').forEach(input => {
                input.checked = false;
            });

            filterCounter.textContent = 0;
            filterCounter.classList.remove('filters-counter--oppened');

            loadReferences(1);

        });

    }

    const closeBtn = document.querySelector('.close');

    if (closeBtn) {

        closeBtn.addEventListener('click', () => {

            form.classList.remove('form--openned');
            formOverlay.classList.remove('form--openned');

        });

    }

    const displayResults = document.querySelector('.display-results');

    if (displayResults) {

        displayResults.addEventListener('click', () => {

            form.classList.remove('form--openned');
            formOverlay.classList.remove('form--openned');

        });

    }

    const openFilters = document.querySelector('.references-filters-button');

    if (openFilters) {

        openFilters.addEventListener('click', () => {

            form.classList.add('form--openned');
            formOverlay.classList.add('form--openned');

        });

    }

    const updateSelectedFiltersCount = () => {

        const count = document.querySelectorAll(
            '.filter-group__labels input[type="checkbox"]:checked'
        ).length;

        filterCounter.textContent = count;

        if (count > 0) {
            filterCounter.classList.add('filters-counter--oppened');
        } else {
            filterCounter.classList.remove('filters-counter--oppened');
        }

    };

    document.querySelectorAll(
        '.filter-group__labels input[type="checkbox"]'
    ).forEach(filter => {

        filter.addEventListener('change', updateSelectedFiltersCount);

    });

}